"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.random = exports.shuffle = void 0;
var Random = require("../Utils/Random");
/**
 * Shuffle an array.
 * @param pArray
 */
function shuffle(pArray) {
    var temp;
    var index;
    for (var i = 0; i < pArray.length; ++i) {
        index = Random.intBetween(0, pArray.length);
        temp = pArray[i];
        pArray[i] = pArray[index];
        pArray[index] = temp;
    }
}
exports.shuffle = shuffle;
/**
 * Get a random array element.
 * @param pArray
 */
function random(pArray) {
    return pArray[Random.intBetween(0, pArray.length)];
}
exports.random = random;
//# sourceMappingURL=ArrayUtils.js.map